import Vue from 'vue'
import vbclass from 'vue-body-class'
import Router from 'vue-router'
import Home from '@/components/Home'
import Isa from '@/components/Isa'
import Gallery from '@/components/Gallery'


Vue.use( Router,  )

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/isa',
      name: 'Isa',
      component: Isa
    },
    {
      path: '/gallery',
        name: 'Gallery',
        meta: { bodyClass: 'gallery' },
        component: Gallery
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js